/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-07T11:35:36-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-14T15:11:48-07:00
*/


import React from 'react';
import { dimensions, spacing, color, type, textColor, borders } from '../../style';
import {Link} from 'react-router';
import { css } from 'glamor'

const style = {
  button: {
    // ...type.BOLD,
    display: 'inline-flex',
    fontSize: '15px',
    fontWeight: '700',
    padding: '10px 16px',
    border: '1px solid transparent',
    backgroundColor: 'transparent',
    borderRadius: '3px',
    justifyContent: 'center',
    whiteSpace: 'nowrap',

    [':focus']: {
      outline: 'none'
    }
  },

  linkStyle: {
    color: color.BRAND_1,
    ...type.BOLD
  },

  large: {
    height: '42px',
    fontSize: '16px'
  },

  fit: {
    display: 'block',
    boxSizing: 'border-box',
    width: '100%'
  },

  disabled: {
    backgroundColor: color.GREY_1,
    pointerEvents: 'none',
    ...textColor.LIGHTER

  },

  padded: {
    ...spacing.PADDING_H_SM
  },

  /**
   * Button Container
   */

   buttonContainer: {
     display: 'flex',
     flexWrap: 'nowrap',
     justifyContent: 'center',
     alignItems: 'center',
     textAlign: 'center',
     flexFlow: 'row'
   },


   /**
    * Sizes
    */


    large: {
      padding: '14px 20px'
    },

  //Color Variants

  primary: {
    backgroundColor: color.BRAND_1,
    color: '#FFF',
  },

  primaryFocus: {
    [':focus']: {
      backgroundColor: color.BRAND_1_DARK
    }
  },

  //-------

  simple: {
    borderColor: "rgba(0,0,0,0.15)",
    ...textColor.DARKER
  },

  simpleFocus: {
    [':focus']: {
      borderColor: 'rgba(0,0,0,0.05)'
    }
  },
};

const Button = (props) => {

  const {
    variant,
    fit,
    disabled,
    padded,
    size,
    extraStyles,
    focusable,
    ...rest
  } = props

  const focusVariant = (variantName) => {
    return style[`${variantName}Focus`]
  }

  const classNames = () => {
    return [
      variant == "simple" && style.simple,
      variant == "primary" && style.primary,
      variant == "link" && style.linkStyle,
      fit && style.fit,
      disabled && style.disabled,
      padded && style.padded,
      size && style[props.size],
      focusable && focusVariant(variant)
    ]
  }

    if (props.to) {
      return (
        <Link
          to={props.to}
          className={css(style.button, classNames())}
        >
          <div className={css(style.buttonContainer)}>
            {props.children}
          </div>
        </Link>
      )
    } else {
      return (
        <button
          className={css(style.button, classNames())}
          style={extraStyles}
          disabled={disabled}
          {...rest}
          >
          {props.children}
        </button>
      )
    }
};

Button.propTypes = {
  children: React.PropTypes.node,
  onClick: React.PropTypes.func,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/blocks/Button.jsx